import React from 'react';

import Button from 'components/modules/button/Button';
import UiStackTemplate from 'components/templates/UiStackTemplate';

import CSSModule from './AccountRegistrationEmailSent.module.scss';

interface Props {
  email: string;
  isFetching: boolean;
  onResend: () => void;
  onCancel: () => void;
}

const AccountRegistrationEmailSent: React.FC<Props> = ({
  email,
  isFetching,
  onResend,
  onCancel,
}) => (
  <div className={CSSModule.AccountRegistrationEmailSent}>
    <UiStackTemplate isLoading={isFetching}>
      <div className={CSSModule.AccountRegistrationEmailSent__Inner}>
        <h2 className={CSSModule.AccountRegistrationEmailSent__Title}>
          送信されたメールを確認してください
        </h2>
        <p className={CSSModule.AccountRegistrationEmailSent__Description}>
          <span className={CSSModule.AccountRegistrationEmailSent__Email}>
            {email}
          </span>
          へメールを送信しました。
          <br />
          メールに記載されたURLから本登録の手続きを行ってください。
        </p>
        <p className={CSSModule.AccountRegistrationEmailSent__Remark__First}>
          ※ URLの
          <strong
            className={CSSModule.AccountRegistrationEmailSent__Remark__Strong}
          >
            有効期限は10分
          </strong>
          です。期限内に手続きできなかった場合
          <br />
          再度メールアドレスを登録してください。
        </p>
        <p className={CSSModule.AccountRegistrationEmailSent__Remark__Last}>
          ※ メールが届かない場合は、ドメイン指定受信設定で
          <br />
          「@studysapuri.jp」の許可と、URL付きメールの
          <br />
          受信許可設定をしてメールを再送信してください。
        </p>
        <div className={CSSModule.AccountRegistrationEmailSent__Buttons}>
          <Button
            className={CSSModule.AccountRegistrationEmailSent__Button}
            color="primary"
            onClick={onResend}
            disabled={isFetching}
          >
            メールを再送信
          </Button>
          <Button
            className={CSSModule.AccountRegistrationEmailSent__Button}
            color="link"
            onClick={onCancel}
          >
            &lt; 戻る
          </Button>
        </div>
      </div>
    </UiStackTemplate>
  </div>
);

export default AccountRegistrationEmailSent;
